import { Component, OnDestroy, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { GlobalsService } from '../../services/globals.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-favorites',
	templateUrl: './favorites.component.html',
	styleUrls: ['./favorites.component.scss']
})
export class FavoritesComponent implements OnInit, OnDestroy {
	favorites: any = [];
	saveAvailable = false;
	private sub = new Subscription();

	constructor(private globalsService: GlobalsService) {}

	ngOnInit(): void {
		this.sub.add(
			this.globalsService.getFavorites().subscribe((faves: any) => {
				this.favorites = faves || [];
			}));
	}

	drop(event: CdkDragDrop < any[] > ): void {
		moveItemInArray(this.favorites, event.previousIndex, event.currentIndex);
		this.saveAvailable = true;
	}

	removeFavorite(faveid: string): void {
		this.sub.add(
			this.globalsService.removeFavorite({ faveid }).subscribe((faves: any) => {
				this.favorites = faves || [];
				this.saveAvailable = true;
			}));
	}

	saveOrder(): void {
		this.sub.add(
			this.globalsService
				.reorderFavorites({ favorites: this.favorites })
				.subscribe(() => {
					this.saveAvailable = false;
				})
		);
	}

	ngOnDestroy(): void {
		this.sub.unsubscribe();
	}
}